<template>
	<div>
        <form class="form" @submit="onSubmit">
            <h1 class="form__title title title--line" v-if="title" v-html="title">
            </h1>
            <div class="form__error" v-if="error" v-html="error">
            </div>
            <div class="form__intro" v-if="intro" v-html="intro">
            </div>
            <div class="form__intro" v-if="remarks" v-html="remarks">
            </div>

            <div v-for="(field,key) in fields">
                <component
                        :is="getComponent(field)"
                        :name="key"
                        :type="field.type"
                        :title="field.label"
                        :required="field.mandatory"
                        :description="field.description"
                        :helpText="field.helpText"
                        :selectOptions="field.options"
                        :error="field.errorMessage"
                        :value="field.value"
                        :maxLength="field.maxLength"
                        v-model="formData[key]"
                >
                </component>
            </div>

            <slot name="buttons">
                <button class="button form__button" type="submit">
                    {{ buttonLabel }}
                </button>
            </slot>
        </form>
	</div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: 'Form',
        data: function(){
            return {
                formData: {},
                // add this to data so we can manipulate this value when the submit fails
                fields: this.controls
            }
        },
	    props: {
            action: {
                type: String,
            },
            title: {
                type: String,
            },
            intro: {
                type: String,
            },
            remarks: {
                type: String,
            },
            formid: {
                type: String,
            },
            csrf: {
                type: String,
            },
            error: {
                type: String,
            },
            controls: {
                type: Object,
                mandatory: true,
            },
            buttonLabel: {
                type: String,
                default: function () {
                    return 'Verzenden';
                }
            }
	    },
        computed: mapState(['activeLocale']),
        watch: {
            // when the activeLocale change then try to translate again
            controls(newValue) {
                this.fields = newValue;
            },
        },
        methods: {
            onSubmit: function (e) {
                e.preventDefault();

                this.$store.commit('setLoading',true);

                // reset the errors first
                for (const [key, field] of Object.entries(this.fields)) {
                    field.errorMessage = null;
                }
                // construct the post data
                let data = new FormData();
                _.each(this.formData,function(item,key) {
                    var value = item;

                    if(_.isObject(value)) {
                        value = Object.values(value)
                    }

                    // only add if the key has a value
                    if(value) {
                        data.append(key,value);
                    }
                });

                // always add a form id
                data.append('formid', this.formid);
                data.append('csrf', this.csrf);

                this.$Api.post(this.action, data)
                    .then(this.processSubmitResponse)
            },
            update: function(data) {
                this.fields = data.controls;
                this.error = data.error;
            },
            processSubmitResponse: function(response) {
                var self = this;

                //Fix issue empty or no response body
                if(! response.data){
                   this.$router.push({name: '500', params:{}});
                }

                var data = response.data;
                if(data.success) {
                    this.$emit('submitSuccess',response.data);
                } else {
                    self.update(data);
                }
            },
            getComponent: function(field) {
                switch (field.type.toLowerCase()) {
                    case 'checkbox':
                        return 'FieldCheckbox';
                    case 'checkboxes':
                        return 'FieldCheckboxes';
                    case 'date':
                        return 'FieldDate';
                    case 'email':
                        return 'FieldEmail';
                    case 'radio':
                        return 'FieldRadio';
                    case 'select':
                        return 'FieldSelect';
                    case 'textarea':
                        return 'FieldTextarea';
                    case 'text':
                        return 'FieldText';
                }
            },
            setDefaultValues: function() {
                let self = this;

                _.each(self.fields,function(item,key) {
                    if(item.value) {
                        self.formData[key] = item.value;
                    }
                });
            }
        },
        created: function() {
            this.setDefaultValues();
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/form/components/Form.vue